<div [class.subaccordion]="!isSubAccordion">
  <span class="toggle-header" tabindex="0" role = "button" [attr.aria-expanded] = "option.isActive?'true':'false'" (keydown)="handleSpanKeydown($event, option)" (click)="selectTab(option, $event)" [attr.aria-label]="option.isActive?option.ariaLabel.collapse:option.ariaLabel.expand+option.category" [ngClass]="{'disabled' : disabled}">
    <div>
      <span class="accheader" *ngIf="!option.isActive" aria-expanded="false" [innerHtml]="option.category" [attr.aria-label]="option.ariaLabel.expand"> </span>
      <span class="accheaderActive"  *ngIf="option.isActive" aria-expanded="true" [innerHtml]="option.category" [attr.aria-label]="option.ariaLabel.collapse"> </span>
      <span *ngIf="!option.isActive">
        <i  *ngIf="!disabled" class="icon-accordion-plus" (keyup)="handleSpanKeydown($event, option)" [attr.aria-label]="option.ariaLabel.expand"></i>
        <i *ngIf="disabled" class="icon-disabled-accordion" [attr.aria-label]="option.ariaLabel.expand"></i>
      </span>
      <i *ngIf="option.isActive" class="icon-accordion-minus" (keyup)="handleSpanKeydown($event, option)"
        [attr.aria-label]="option.ariaLabel.collapse"></i>
    </div>
  </span>
  <div [class.showpanel]="!option.isActive">
    <div class="acc-content">
      <ng-content> </ng-content>
    </div>
  </div>
</div>